/* Copyright (c) 2020-present CloudIO Inc */

import { attachmentProps } from 'componentregistry/utils/commonProps';
import { Platform } from '../../../../platform/Platform';
import {
  ComponentManager,
  ComponentManagerFn,
  ViewAttributeChooserProp,
} from '../../../../registry/Component.type';
import { ItemType } from '../../../../registry/ComponentRegistry';
import { baseComponentManager } from '../../../../registry/Components';
import { baseColumnProps, isBaseColumnPropertyVisible } from '../BaseColumn';
import { defaultValue } from './AttachmentColumn';

const AttachmentColumnManager: ComponentManagerFn<'AttachmentColumn'> = (
  platform: Platform,
): ComponentManager<'AttachmentColumn'> => {
  return {
    ...baseComponentManager<'AttachmentColumn'>(platform, 'AttachmentColumn'),
    type: 'AttachmentColumn',
    name: 'Attachment Column',
    isChildAllowed: (page, item, childType) =>
      (['ColumnFooter', 'TriggerOnChange'] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      ...baseColumnProps,
      viewAttribute: {
        ...(baseColumnProps.viewAttribute as ViewAttributeChooserProp),
        getAttributeDataTypes: () => ['Attachment'],
      },
      ...attachmentProps,
    },
    getDisplayText: (item) =>
      typeof item.props.label === 'string'
        ? item.props.label
        : item.props.label.value ?? '',
    isPropertyVisible(prop, itemData, { appUid, itemId, pageId }): boolean {
      if (
        itemId &&
        !isBaseColumnPropertyVisible({ appUid, platform, itemId, pageId, prop })
      ) {
        return false;
      }
      switch (prop) {
        case 'accept': {
          return !itemData.images;
        }
        case 'imageHeight':
        case 'showImage':
        case 'maxImageWidth': {
          return itemData.images;
        }
        case 'toolTip':
        case 'toolTipPosition':
        case 'toolTipMaxWidth':
          return false;
        default:
          return true;
      }
    },
    generateShortId: (item) =>
      typeof item.label === 'string' ? item.label : item.label?.value,
    category: 'Data Grid',
    icon: { iconName: 'paperclip' },
    description: `Use this to allow user to upload files.
Use \`Trigger On Change\` child action to perform further actions after uploading the file.
\`\`\`javascript
// Access the file information as below using expression builder
\`\${$._.file.fileName} \${$._.file.fileSize} \${$._.file.contentType} \${$._.file.fileVersion} \${$._.file.fileUid}\`
\`\`\`

`,
  };
};

export default AttachmentColumnManager;
